import { render, staticRenderFns } from "./profileColl.vue?vue&type=template&id=66803de2&scoped=true"
import script from "./profileColl.vue?vue&type=script&lang=js"
export * from "./profileColl.vue?vue&type=script&lang=js"
import style0 from "./profileColl.vue?vue&type=style&index=0&id=66803de2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66803de2",
  null
  
)

export default component.exports